export const DEFAULT_CLASS_TYPE = "online";

export const onlineTypeOptions = [
	{ label: "Online", value: "online" },
	{ label: "In-person", value: "offline" },
];

export const onlineOption = [{ label: "Online", value: "online" }];

export const offlineOption = [{ label: "In-person", value: "offline" }];
